const questionFilter = (question) =>
  !question.isHidden() &&
  // Skip questions with empty descriptions
  !(question.isSection() && !question.getDescription());

export default questionFilter;
